cwc-map-content.single-location cwc-map {
  display: block;
  height: 500px;
  width: 70%;
  float: left;
}

cwc-map-content.single-location cwc-map-location {
  width: 30%;
  min-height: 500px;
  display: inline-block;
  padding-left: 50px;
}

cwc-map-content.single-location .info-content > div {
  margin-top: 2.5rem;
}

cwc-map-content.single-location .back-to-locations,
cwc-map-content.single-location .location-back {
  display: block;
  width: 100%;
  border: none;
  background: none;
  text-align: left;
  color: var(--color-primary, #c30c15);
  align-items: center;
  font-size: 14px;
  line-height: 1;
  margin-bottom: 15px;
}

cwc-map-content.single-location .back-to-locations .icon-arrow-left,
cwc-map-content.single-location .location-back .icon-arrow-left {
  margin-left: -5px;
}

cwc-map-content.single-location .shadow {
  padding: 0;
  box-shadow: unset;
}

cwc-map-content.single-location #mode-selector label {
  text-align: left;
  background-color: inherit;
}

cwc-map-content.single-location #mode-selector input[type='radio']:checked + label {
  background-color: inherit;
}

cwc-map-content.single-location .slidecontainer,
cwc-map-content.single-location .adp-list {
  display: none;
}

cwc-map-content.single-location cwc-location-itinerary h3 {
  font-size: large;
}

cwc-map-content.single-location cwc-location-itinerary.show {
  margin-bottom: 15px;
  margin-top: 0;
}

cwc-map-content.single-location .address > span,
cwc-map-content.single-location .phone > span,
cwc-map-content.single-location .hours > span {
  display: inline-block;
  width: 40px;
  font-size: 32px;
  color: var(--color-primary, #c30c15);
  margin-top: 2px;
}

cwc-map-content.single-location .phone > span {
  margin: 0;
}

cwc-map-content.single-location .hours > span {
  font-size: 23px;
  padding-left: 5px;
  font-weight: 600;
}

cwc-map-content.single-location .address > div,
cwc-map-content.single-location .phone > div,
cwc-map-content.single-location .hours > div {
  display: inline-block;
  vertical-align: top;
  width: 220px;
}

cwc-map-content.single-location .phone > div {
  line-height: 32px;
}

cwc-map-content.single-location cwc-map-control.controls.location-control {
  margin-bottom: 20px;
}

cwc-map-content.single-location .icon-arrow-left.red::before {
  margin: 0;
  vertical-align: text-bottom;
}

cwc-map-content.single-location cwc-product-images .preview-items-wrapper {
  width: 70%;
}

cwc-map-content.single-location cwc-product-images button.icon-arrow-left,
cwc-map-content.single-location cwc-product-images button.icon-arrow-right {
  top: 48%;
}

cwc-map-content.single-location .directions-panel {
  overflow-y: auto;
  max-height: 380px;
  width: 100%;
  margin: 0;
}

cwc-map-content.single-location .directions-panel .adp-directions tr {
  border-bottom: none;
  background-color: unset;
}

cwc-map-content.single-location .directions-panel .adp-substep:nth-child(2) {
  padding-left: 0;
}

cwc-map-images {
  display: block;
  width: 100%;
  overflow: hidden;
  max-height: 99px;
  margin: 15px 0 30px;
}

cwc-map-images .img-items {
  display: block;
}

cwc-map-images .img-item {
  display: inline-block;
  width: 150px;
  padding-right: 3px;
  cursor: pointer;
}

@media only screen and (max-width: 768px) {
  cwc-map-content.single-location cwc-product-images .preview-items-wrapper {
    width: 90%;
  }

  cwc-map-images {
    display: contents;
  }

  cwc-map-images .img-items {
    position: relative;
    top: 0;
    left: 10px;
    padding-bottom: 10px;
  }

  cwc-map-images .img-item {
    width: calc(50% - 10px);
    padding: 0 2px;
  }
}

@media only screen and (max-width: 1024px) {
  cwc-map-content.single-location cwc-map-location {
    width: 40%;
    min-height: 500px;
    padding-left: 20px;
  }

  cwc-map-content.single-location cwc-map {
    width: 60%;
    height: 500px;
  }
}

@media only screen and (max-width: 820px) {
  cwc-map-content.single-location cwc-map-location {
    width: 40%;
    min-height: 420px;
    padding: 0 0 0 20px;
  }

  cwc-map-content.single-location cwc-map {
    width: 60%;
    height: 420px;
  }
}

@media only screen and (max-width: 541px) {
  cwc-map-content.single-location cwc-map-location {
    width: 100%;
    padding: 20px;
  }

  cwc-map-content.single-location cwc-map {
    width: 100%;
    height: 300px;
  }
}
